import { render, staticRenderFns } from "./SceneSetting.vue?vue&type=template&id=b37ce16e&scoped=true&"
import script from "./SceneSetting.vue?vue&type=script&lang=js&"
export * from "./SceneSetting.vue?vue&type=script&lang=js&"
import style0 from "./SceneSetting.vue?vue&type=style&index=0&id=b37ce16e&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b37ce16e",
  null
  
)

export default component.exports